'use client'
import { sendFacebookPageView } from '@/features/save-log/services'
import { useEffect, useRef } from 'react'

/**
 * Component để gửi Facebook PageView tracking lên server
 * - Chỉ call API khi user load/refresh trang web (F5)
 * - Không call API khi user chuyển route trong app (client-side navigation)
 * - Sử dụng performance.navigation.type để detect page reload
 */
export const SendFacebookPageView = () => {
  const hasTrackedRef = useRef(false)

  useEffect(() => {
    // Chỉ track 1 lần duy nhất khi component mount lần đầu
    if (hasTrackedRef.current) return

    // Đánh dấu đã track để tránh call lại
    hasTrackedRef.current = true

    // Call API để gửi Facebook PageView
    sendFacebookPageView()
      .then((result) => {
        if (result?.status === 'success') {
          console.log('✅ Facebook PageView đã được gửi thành công')
        } else if (result?.status === 'error') {
          console.error('❌ Lỗi khi gửi Facebook PageView:', result.message)
        }
      })
      .catch((error) => {
        console.error('❌ Failed to send Facebook PageView:', error)
      })
  }, [])

  // Component không render gì cả
  return null
}
